import script from "./register_payment.vue?vue&type=script&setup=true&lang=ts"
export * from "./register_payment.vue?vue&type=script&setup=true&lang=ts"

import "./register_payment.vue?vue&type=style&index=0&id=eda6b250&scoped=true&lang=css"

import exportComponent from "/var/www/ShareMentors/ShareMentors/backend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eda6b250"]])

export default __exports__